module.exports = __webpack_public_path__ + "static/awards-06-e5a02d65fcb986dd9236f5a224d0e479.png";